// Telegram WebApp SDK helper & environment detector

declare global {
  interface Window {
    Telegram?: {
      WebApp: any;
    };
  }
}

export function isTelegramMiniApp(): boolean {
  return typeof window !== 'undefined' && Boolean(window.Telegram?.WebApp?.initData);
}

export function getTelegramWebApp(): any | null {
  if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
    return window.Telegram.WebApp;
  }
  return null;
}

export function initTelegramApp() {
  const tg = getTelegramWebApp();
  if (tg) {
    try {
      tg.ready();
      tg.expand();
      // Apply Obsidian dark theme to Telegram header & background
      if (tg.setHeaderColor) tg.setHeaderColor('#0A0E17');
      if (tg.setBackgroundColor) tg.setBackgroundColor('#0A0E17');
    } catch {
      // Ignore errors if running in standalone web
    }
  }
}

export function getTelegramInitData(): string {
  const tg = getTelegramWebApp();
  return tg?.initData || '';
}

export function getTelegramUser(): any | null {
  const tg = getTelegramWebApp();
  return tg?.initDataUnsafe?.user || null;
}
